import { inject, Injectable } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { FacetsState } from './facets.state';
import type { FacetChangeOrigin, FacetGroup } from './models/facets.model';
import { ApplyFacets, GetFacets, ResetFacets, ResetStore, SetFacet } from './facets.actions';
import type { SearchCriteriaFacets } from 'src/app/search/service/search.model';

@Injectable({
  providedIn: 'root',
})
export class FacetsFacade {
  private readonly store = inject(Store);

  @Select(FacetsState.facetGroups) facetGroups$!: Observable<FacetGroup[]>;
  @Select(FacetsState.isLoading) isLoading$!: Observable<boolean>;
  @Select(FacetsState.buttonDisplayInfo) buttonDisplayInfo$!: Observable<{label: string; count: number}>;
  @Select(FacetsState.criteriaFacets) criteriaFacets$!: Observable<SearchCriteriaFacets>;

  get facetGroups() {
    return this.store.selectSnapshot(FacetsState.facetGroups);
  }

  get isLoading() {
    return this.store.selectSnapshot(FacetsState.isLoading);
  }

  get title() {
    return this.store.selectSnapshot(FacetsState.title);
  }

  get criteriaFacets() {
    return this.store.selectSnapshot(FacetsState.criteriaFacets);
  }

  resetStore() {
    this.store.dispatch(new ResetStore());
  }

  getFacets() {
    return this.store.dispatch(new GetFacets());
  }

  setFacet(id: string, origin: FacetChangeOrigin = 'dialog') {
    this.store.dispatch(new SetFacet(id, origin));
  }

  applyFacets() {
    this.store.dispatch(new ApplyFacets());
  }

  resetFacets() {
    this.store.dispatch(new ResetFacets());
  }
}
